// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2023 LiveKit, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

body {
  padding: 0;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: black;
  color: rgb(211, 210, 210);
  box-sizing: border-box;
  margin: 0;
  height: 100vh;
  font-size: 12px;
  overflow: hidden;
}

.light {
  background: white;
}

.roomContainer {
  height: 100vh;
}

.error {
  color: red;
}

.lk-grid-layout-wrapper {
  height: 100%;
}

.lk-focus-layout {
  height: 100%;
}

/* things like name, connection quality, etc make less sense in a recording, hide for now */
.lk-participant-metadata {
  display: none;
}

.lk-participant-media-video[data-lk-orientation="portrait"] {
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,UAAU;EACV;wEACsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,2FAA2F;AAC3F;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/**\n * Copyright 2023 LiveKit, Inc.\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\nbody {\n  padding: 0;\n  font-family: Avenir, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: black;\n  color: rgb(211, 210, 210);\n  box-sizing: border-box;\n  margin: 0;\n  height: 100vh;\n  font-size: 12px;\n  overflow: hidden;\n}\n\n.light {\n  background: white;\n}\n\n.roomContainer {\n  height: 100vh;\n}\n\n.error {\n  color: red;\n}\n\n.lk-grid-layout-wrapper {\n  height: 100%;\n}\n\n.lk-focus-layout {\n  height: 100%;\n}\n\n/* things like name, connection quality, etc make less sense in a recording, hide for now */\n.lk-participant-metadata {\n  display: none;\n}\n\n.lk-participant-media-video[data-lk-orientation=\"portrait\"] {\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
